export const isClearResponse = (message) => {
    return (message.error === null && typeof message.id === 'number');
};
//# sourceMappingURL=/build/es2018/guards/clear-response.js.map